export const FaqContent = [
  {
    question: 'What separates Vy Media Group from any other Affiliate Network?',
    answer: [
      'VMG takes a hands on approach and works directly with Affiliates & Advertisers. We are real life Affiliate Marketers and Media Buyers with several years of experience in the industry. We’ve been in the trenches and understand both the Affiliate, Advertiser, and Network side of the business.',
      'We have been on the forefront of Media Buying and have trained thousands of Affiliates collectively resulting in hundreds of millions in online sales.',
    ],
  },
  {
    question: 'What are your Payout Schedules?',
    answer: [
      'All Affiliates start out on standard Net15 terms. With quality traffic and $1,000+ USD per week revenues you will be moved to weekly Net7. Minimum payout threshold to qualify for payment is $500 USD.',
    ],
  },
  {
    question: 'How do we receive a payment on VMG Network?',
    answer: [
      'VMG requires all proper W9 W8 BEN Tax forms to be completed, signed, and on file prior to release of any payments. VMG sends US Domestic and International payments via Bank Wire. US Based Affiliates qualify for next day ACH Payments. There is a $30 US same day Domestic Wire Fee, a $45 International Wire Fee, and a $10 next day ACH fee.',
    ],
  },
  {
    question: 'How do I get started working with the VMG?',
    answer: [
      'Signup and fill out the application form and answer the questions accurately and our team will review your application and contact you for approval.',
    ],
  },
  {
    question: 'How much does it cost to become a VMG Affiliate or Advertiser?',
    answer: [
      'There is no cost to become an Affiliate or Advertiser with VMG. There is however a screening process and not everyone who applies will be approved.',
      'We take quality and fraud very seriously and all applicants will be fully vetted prior to acceptance into our network.',
    ],
  },
];
